module.exports = __webpack_public_path__ + "static/img/VIGO-VISENTINI.25c705e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VIGO-VISENTINI.jpg
// module id = VBgA
// module chunks = 0